interface UseBtnPrimaryOptions {
  onClick: () => void
}

interface UseBtnPrimaryReturn {
  handleClick: () => void
}

export const useBtnPrimary = ({ onClick }: UseBtnPrimaryOptions): UseBtnPrimaryReturn => {
  const handleClick = (): void => {
    onClick()
  }

  return {
    handleClick,
  }
}
